import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
// import Home from "./pages/Home/Home";
import Home from "./pages/Home/Home2";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Work from "./pages/Work/Work";
import { initAnalytics } from "./utils/analytics";
import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    initAnalytics();

    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 2800);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <AnalyticsTracker />

      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/work" element={<Work />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
